import React from 'react'
import { StyleSheet, TouchableOpacity, View, Platform } from 'react-native'
import { Icon, Text, useTheme } from '@ui-kitten/components'

export default function HeaderIconButton( { iconName=null, text=null, onPress, style=null, testID='header-icon-button' } ) {
  const theme = useTheme()
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[styles.button, style]}
      testID={testID}
      {...(Platform.OS === 'web' ? { dataSet: { testid: testID } } : {})}
    >
      <View style={styles.view}>
        { iconName && <Icon name={iconName} height={24} width={24} fill={theme['text-basic-color']} /> }
        { text && <Text>{text}</Text> }
      </View>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  view: {
    height: 24,
    flexDirection: 'row',
    alignItems: 'center'
    // width: 24,
  },
  button: {
    padding: 10,
  }
})
